import { render, staticRenderFns } from "./PagesHeading.vue?vue&type=template&id=a45c44f0"
import script from "./PagesHeading.vue?vue&type=script&lang=js"
export * from "./PagesHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports